<template>
    <!-- modal-xl -->
    <b-modal id="dataQCModal" size="xl" title="Data QC Modal" title-class="font-18" hide-footer>
        <div class="row row-container">
            <div class="left-pane">
                <b-form-group label="Supplier Name:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled v-model="selected_supplier_details.company_name" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="BEE Level:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled value="not editable" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Economic Interest:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled value="not editable" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Voting Rights:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled value="not editable" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Vat no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled value="not editable" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>
                <b-form-group label="Reg no:" label-for="" class="b-form-group align-text-setting" label-cols-sm="4" label-size="sm">
                    <b-form-input disabled value="not editable" type="text" class="b-form-input" size="sm"></b-form-input>
                </b-form-group>

                <div class="group-of-actions mt-2">
                    <b-form-group label="Notes:" label-for="textarea-formatter" class="">
                        <b-form-textarea id="textarea-formatter" placeholder="Editable"></b-form-textarea>
                    </b-form-group>

                    <b-button variant="primary" type="button" class="btn btn-primary ml-2 pl-4 pr-4">
                        Ok
                    </b-button>
                    <b-button variant="primary" type="button" class="btn btn-primary ml-2 pl-4 pr-4">
                        Fix
                    </b-button>
                </div>
            </div>

            <div class="right-pane">
                <div>
                    <b-button variant="primary" class="btn btn-primary float-right mb-2"><i class="mdi mdi-dock-window mr-1"></i> View</b-button>
                </div>
                <embed src="example-pdf.pdf#page=1&zoom=50&toolbar=0" class="w-100 h-100" />
            </div>
        </div>

        <div class="modal-footer mt-3">
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { suppliersComputed } from "../../state/helpers";

export default {
    data: () => ({}),
    computed: { ...suppliersComputed },
    methods: {
        closeModal() {
            this.$bvModal.hide("dataQCModal");
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
//   the default style attached to modal footer  border-top: 1px solid #eff2f7;
.align-text-setting {
    text-align: right;
}
.height {
    min-height: 500px;
}

// this makes the left and right pane in the flex
.row-container {
    display: flex;
    padding: 10px;
}

.left-pane {
    width: 40%;

    .b-form-group {
        margin-right: 50px;
    }
    .b-form-input {
        max-width: 100%;
    }
}
.group-of-actions {
    border-top: 1px solid #eff2f7 !important;
    // margin-top: 25px;
    padding-top: 15px;
    margin-right: 25px;
}

.right-pane {
    width: 60%;
    display: flex;
    flex-direction: column;
}

// the purpose of this media query is simply to make the contents of modal display flex-column
// and then for the panes to have a width off 100% instead of 50%
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
    .row-container {
        flex-direction: column;
    }

    .left-pane {
        width: 100%;
    }

    .right-pane {
        width: 100%;
        margin-top: 25px;
        height: 350px;
    }
}
</style>
